import React, { useEffect, useState } from "react";
import "./ProductSIze.scss";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Button, Typography, Spin, message } from "antd";
import { Counter } from "../../../../components";
import Utils from "../../../../utils";
import useCard from "../../../../hooks/useCard";

export default function ProductSIze({ token, product, loading }) {
  const [messageApi, contextHolder] = message.useMessage();
  const openSuccess = () => {
    messageApi.open({
      type: "success",
      content: "Product added to cart",
    });
  };
  const openError = () => {
    messageApi.open({
      type: "error",
      content: "Failed to add product to cart",
    });
  };
  const { addToCard } = useCard();
  const navigate = useNavigate();
  const shop = useSelector((state) => state?.shopDetails?.shop);
  // Shop setting "Show stock counts on shop" (CANA-639); missing key = off.
  const isCountVisible = Boolean(shop?.is_count_visible_on_shop);
  const [count, setCount] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [adding, setAdding] = useState(false);
  const [buying, setBuying] = useState(false);
  // Only cap the picker when the count is shown; otherwise keep today's
  // behaviour and let the backend reject an over-order.
  const maxCount =
    isCountVisible && selectedVariant?.count > 0
      ? selectedVariant.count
      : undefined;

  useEffect(() => {
    if (product?.variants?.length) {
      const first_variant_count_gt0 = Utils?.findVariantCountGt0(
        product?.variants
      );
      setSelectedVariant(first_variant_count_gt0);
    } else {
      setSelectedVariant(null);
    }
  }, [product]);

  useEffect(() => {
    // Switching to a weight with less stock than the picked quantity
    // must pull the quantity back down to what can actually be ordered.
    if (maxCount !== undefined) {
      setCount((prev) => (prev > maxCount ? maxCount : prev));
    }
  }, [maxCount]);

  return (
    <>
      {contextHolder}
      <div className="productSIze-cont">
        {loading ? (
          <Spin
            size="large"
            style={{
              marginTop: "auto",
              marginBottom: "auto",
            }}
          />
        ) : (
          <>
            <div className="productSIze-cont__titleCont">
              {selectedVariant &&
              selectedVariant?.price &&
              selectedVariant?.sale_price &&
              Utils?.isSalePriceValid(
                selectedVariant?.sale_price,
                selectedVariant?.price
              ) ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                  }}>
                  <Typography.Text
                    key={selectedVariant?.id ? selectedVariant?.id : ""}
                    className="productSIze-cont__titleCont__bigTitle"
                    style={{
                      color: token?.Typography?.colorPrimaryText,
                    }}
                    delete>
                    {selectedVariant?.price
                      ? Utils?.roundNumber(
                          count
                            ? count * selectedVariant?.price
                            : selectedVariant?.price
                        )
                      : ""}
                  </Typography.Text>
                  <Typography.Text
                    className="productSIze-cont__titleCont__bigTitle"
                    style={{
                      color: token?.Typography?.mainColorText,
                    }}>
                    {selectedVariant?.price && selectedVariant?.sale_price
                      ? Utils?.roundNumber(
                          count
                            ? count * selectedVariant?.sale_price
                            : selectedVariant?.sale_price
                        )
                      : ""}
                  </Typography.Text>
                </div>
              ) : (
                <Typography.Text
                  className="productSIze-cont__titleCont__bigTitle"
                  style={{
                    color: token?.Typography?.mainColorText,
                  }}>
                  {selectedVariant?.price
                    ? Utils?.roundNumber(
                        count
                          ? selectedVariant?.price * count
                          : selectedVariant?.price
                      )
                    : ""}
                </Typography.Text>
              )}
            </div>
            {/* <div className="productSIze-cont__slidersCont">
        <div className="productSIze-cont__slidersCont__slidercont">
          <Typography.Text
            className="productSIze-cont__secondaryTitle"
            style={{
              color: token?.Typography?.mainColorText,
            }}>
            Relaxed
          </Typography.Text>
          <div
            className="productSIze-cont__slidersCont__slidercont__slide"
            style={{
              backgroundColor: token?.Card?.colorBgCard,
            }}>
            <div
              className="productSIze-cont__slidersCont__slidercont__slide__active"
              style={{
                backgroundColor: token?.colorPrimary,
                width: "50%",
              }}></div>
          </div>
        </div>
        <div className="productSIze-cont__slidersCont__slidercont">
          <Typography.Text
            className="productSIze-cont__secondaryTitle"
            style={{
              color: token?.Typography?.mainColorText,
            }}>
            Boner
          </Typography.Text>
          <div
            className="productSIze-cont__slidersCont__slidercont__slide"
            style={{
              backgroundColor: token?.Card?.colorBgCard,
            }}>
            <div
              className="productSIze-cont__slidersCont__slidercont__slide__active"
              style={{
                backgroundColor: token?.colorPrimary,
                width: "90%",
              }}></div>
          </div>
        </div>
        <div className="productSIze-cont__slidersCont__slidercont">
          <Typography.Text
            className="productSIze-cont__secondaryTitle"
            style={{
              color: token?.Typography?.mainColorText,
            }}>
            Happy
          </Typography.Text>
          <div
            className="productSIze-cont__slidersCont__slidercont__slide"
            style={{
              backgroundColor: token?.Card?.colorBgCard,
            }}>
            <div
              className="productSIze-cont__slidersCont__slidercont__slide__active"
              style={{
                backgroundColor: token?.colorPrimary,
                width: "70%",
              }}></div>
          </div>
        </div>
      </div> */}
            <div className="productSIze-cont__weightCont">
              <Typography.Text
                className="productSIze-cont__secondaryTitle"
                style={{
                  color: token?.Typography?.mainColorText,
                }}>
                Select Weight
              </Typography.Text>
              <div className="productSIze-cont__weightCont__btnWrapper">
                {product?.variants?.map((variant) => (
                  <Button
                    className="productSIze-cont__weightCont__btnWrapper__weight"
                    disabled={variant?.count <= 0}
                    style={{
                      borderColor:
                        variant?.id?.toString() ===
                        selectedVariant?.id?.toString()
                          ? token?.colorPrimary
                          : "",
                    }}
                    key={variant?.id}
                    onClick={() => {
                      if (variant?.count > 0) {
                        setSelectedVariant(variant);
                      }
                    }}>
                    <Typography.Text
                      className="productSIze-cont__secondaryTitle"
                      style={{
                        color:
                          variant?.id?.toString() ===
                          selectedVariant?.id?.toString()
                            ? token?.colorPrimary
                            : "",
                      }}>
                      {variant?.name && variant?.unit
                        ? Utils?.showProductDetail(variant)
                        : ""}
                    </Typography.Text>
                    {isCountVisible && Utils?.showVariantCount(variant) ? (
                      <Typography.Text
                        className="productSIze-cont__weightCont__btnWrapper__weight__count"
                        style={{
                          color: token?.colorTextTertiary,
                        }}>
                        {` · ${Utils?.showVariantCount(variant)}`}
                      </Typography.Text>
                    ) : null}
                  </Button>
                ))}
              </div>
            </div>
            <div className="productSIze-cont__countCont">
              <Typography.Text
                className="productSIze-cont__secondaryTitle"
                style={{
                  color: token?.Typography?.mainColorText,
                }}>
                Quantity
              </Typography.Text>
              <Counter
                count={count}
                max={maxCount}
                onCauntChnage={(val) => {
                  setCount(
                    maxCount !== undefined && val > maxCount ? maxCount : val
                  );
                }}
              />
            </div>
            <div className="productSIze-cont__actionsCont">
              <Button
                loading={adding}
                disabled={loading || !selectedVariant}
                onClick={() => {
                  const result = addToCard(selectedVariant, count, product);
                  if (typeof result?.then === "function") {
                    // Authenticated flow: show loading until the server
                    // confirms, then report the outcome.
                    setAdding(true);
                    result.then((res) => {
                      setAdding(false);
                      if (res?.type === "basket/set_item/fulfilled") {
                        openSuccess();
                      } else {
                        openError();
                      }
                    });
                    return;
                  }
                  openSuccess();
                }}
                style={{ width: "100%", maxWidth: "147px" }}>
                Add to Cart
              </Button>
              <Button
                type="primary"
                loading={buying}
                disabled={loading || !selectedVariant}
                onClick={() => {
                  const result = addToCard(selectedVariant, count, product);
                  if (typeof result?.then === "function") {
                    // Authenticated flow: navigate only after the server
                    // confirms the item is in the basket.
                    setBuying(true);
                    result.then((res) => {
                      setBuying(false);
                      if (res?.type === "basket/set_item/fulfilled") {
                        navigate("/checkout");
                      } else {
                        openError();
                      }
                    });
                    return;
                  }
                  navigate("/checkout");
                }}
                style={{ width: "100%", maxWidth: "147px" }}>
                Buy Now
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
